import { Pixall, Google } from '../analytics/index.js';
import { DataLayerTransformer } from '../transformers/pixall/index.js';
/**
 * @summary Sends Pixall event for CPO program offsite Link
 * @cmp cpo_ofst_lnk
 * @events event1
 */
export async function cpoOffsiteClick(_ref, option) {
  let {
    data = {},
    dataLayer,
    event
  } = _ref;
  const {
    linkIndex = 0,
    pixallData = {}
  } = data;
  const cmp = linkIndex <= 0 ? 'cpo_ofst_lnk' : `ob_link_${linkIndex}`;
  const {
    pageId = '',
    pageInstanceId: pageinstantid = ''
  } = DataLayerTransformer.getPageAttributes(dataLayer);
  const payload = {
    label: cmp,
    eventSource: 'oem',
    pageId,
    pageinstantid,
    ...pixallData
  };
  Pixall.sendClickEvent({
    ...payload
  }, dataLayer, option);
  return payload;
}
export async function cpoFilterTileClick(_ref2, option) {
  let {
    data = {},
    dataLayer
  } = _ref2;
  const {
    cmp,
    spt,
    epn,
    eventSource = 'oem',
    makeCode,
    filterValues
  } = data;
  const extra = {
    cmp,
    epn,
    es: eventSource,
    et: 'click',
    spt
  };
  Pixall.sendClickEvent({
    eventSource,
    eventType: 'click',
    label: cmp,
    vendor: epn,
    make: makeCode,
    hasListingType: false,
    ...(eventSource === 'button' ? {
      filterValues
    } : {})
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'partner',
    eventResult: `certified::${makeCode}`,
    eventData: {
      vehicle: {
        clickType: '',
        listingPosition: ''
      }
    }
  }, option);
  return extra;
}
export default {
  cpoOffsiteClick,
  cpoFilterTileClick
};